import { getUserLang } from '@mb/lib';
import { getContext, getSiteId } from './helpers';
const configGlobal = typeof SEARCH_CONFIG !== 'undefined' ? SEARCH_CONFIG : {};
declare const LANGUAGE: string | undefined;
export const langGlobal = typeof LANGUAGE !== 'undefined' ? LANGUAGE : 'en';
export const envLang =
  typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : 'US';
const SEARCH_DEV =
  (configGlobal?.product?.siteUrl?.replace(/\/$/, '') ||
    'https://search.materialbank.com/v2') + '/';
const SEARCH_HISTORY_LIMIT = 5;

const lang = `${getUserLang()}-${envLang}`;

export const siteId = getSiteId();
const context = getContext();
const isInspiration = window.location.pathname?.includes('inspiration');
const suggestApiPath = isInspiration ? 'inspiration/suggest' : 'suggest';

const config = {
  endpoints: {
    getHistoryByEmail: (email: string) =>
      `${SEARCH_DEV}user/history?lang=${lang}&siteId=${siteId}&context=${context}&email=${email}&limit=${SEARCH_HISTORY_LIMIT}`,
    deleteHistoryItem: (value: string, email: string) =>
      `${SEARCH_DEV}user/history/${value}?&siteId=${siteId}&context=${context}&email=${email}`,
    getSuggestions: (
      query: string,
      additionalParam: string = '',
      context = 'all',
    ) =>
      `${SEARCH_DEV}${suggestApiPath}?siteId=${siteId}&lang=${lang}&context=${context}&q=${encodeURIComponent(
        query,
      )}${additionalParam}`,
    getDefaultSuggestions: `${SEARCH_DEV}analytics?siteId=${siteId}&lang=${lang}&context=${context}`,
    clearHistory: (email: string) =>
      `${SEARCH_DEV}user/history?lang=${lang}&siteId=${siteId}&context=${context}&email=${email}`,
    analytics: SEARCH_DEV + 'analytics/event/adhoc',
    postImage: '/rest/V2/sdg-api/matches/mine/items',
  },
};

export { config };
